import Link from 'next/link';
import React, { useState } from 'react'
import { User } from '../../../models';
import { getTimeFrom } from '../../../utils/DisplayUtils';
import ProBadgeSvg from '../../svgs/ProBadgeSvg';
import Avatar from './Avatar';
import ProInsignia from './ProInsignia';


interface Props {
  user: User;
  publishDate: string
}
const UserPublishDate: React.FC<Props> = ({ user, publishDate }) => {
  return (
    <div className="flex justify-center  w-max space-x-2">
      <div>
        <Avatar user={user} width={45} height={45} />
      </div>
      <div>
        <div className="text-black dark:text-white font-bold flex flex-row items-center">
          <div className="mr-1">{user.first}</div>
          <ProInsignia user={user} />
        </div>
        <p className="text-gray-700 dark:text-gray-400">{getTimeFrom(publishDate)}</p>
      </div>
    </div>
  )
}


export default UserPublishDate;